module.exports = require("core-js-pure/features/instance/index-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/index-of.js
// module id = 477
// module chunks = 13